export default __webpack_public_path__ + "static/media/logo.024c886a.png";